import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ReportFormFieldComponent } from './report-form-field.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, MatInputModule, MatIconModule, MatDatepickerModule, MatNativeDateModule],
  exports: [ReportFormFieldComponent],
  declarations: [ReportFormFieldComponent]
})
export class ReportFormFieldModule {}
